import { useEffect } from 'react'
import styled from 'styled-components'
import useAnimateNumber from 'use-animate-number'
import UsersCarousel from 'home/users-carousel'
import Wrapper from 'common/wrapper'
import { Typography } from 'common/typography'
import { useTotalUsers } from 'querys/growth'
import { PinkGradient } from 'home/platform'

const OpinionsCarouselStyled = styled.section`
  background: linear-gradient(180deg, #082054 1.47%, rgba(4, 0, 30, 0.9) 100%);
  padding-block-start: 104px;
  overflow-x: hidden;
  h1 {
    ${PinkGradient}
  }
  .carousel {
    margin-block-end: 220px;
  }
  .subtitle {
    max-width: 610px;
    margin: 0 auto;
    margin-block-end: 24px;
    margin-block-start: 24px;
  }
  .form-link {
    display: block;
    width: fit-content;
    margin: 0 auto;
    color: var(--turquoise);
    font-weight: 600;
    text-decoration: underline;
    margin-block-start: 48px;
  }
  .number {
    min-width: 90px;
  }
  @media (min-width: 768px) {
    .number {
      min-width: 212px;
    }
  }
  @media (min-width: 1024px) {
    padding-block-start: 80px;
    .subtitle {
      margin-block-end: 48px;
      margin-block-start: 48px;
    }
  }
`

function randomIntFromInterval(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

function OpinionsCarousel() {
  const { data } = useTotalUsers()
  const initalRandom = data?.count - randomIntFromInterval(10, 30)
  const [value, setValue] = useAnimateNumber(
    initalRandom,
    {
      duration: 3000,
      decimals: 0,
      enterance: false,
    },
  )

  useEffect(() => {
    setTimeout(() => {
      setValue(data.count)
    }, randomIntFromInterval(1500, 2000))
  }, [])

  return (
    <OpinionsCarouselStyled>
      <Wrapper maxWidth="1200">
        <Typography as="h1" small="headline4" large="headline1" align="center">
          Más de
          <span className="number">
            {' '}
            {value}
            {' '}
          </span>
          profesionales están aprendiendo con nosotros
        </Typography>
        <Typography className="subtitle" as="p" small="regular" align="center">
          Personas de todo el mundo están mejorando sus habilidades con nosotros
        </Typography>
      </Wrapper>
      <div className="carousel">
        <UsersCarousel />
        <a className="form-link" href="https://forms.gle/B5837ViEsaQ1x1AX7" target="_blank" rel="noopener noreferrer">
          Quiero aparecer aquí
        </a>
      </div>
    </OpinionsCarouselStyled>
  )
}

export default OpinionsCarousel
